<template>
  <v-container grid-list-md page>
    <v-flex>
      <h1 class="title primary--text my-3">お問い合わせ</h1>
      <p>当システムに関するご意見・ご要望、ご不明点などがございましたら下記より、お気軽にお問い合わせください。</p>
      <v-card flat>
        <v-form ref="form" @submit.prevent="submit">
          <v-container grid-list-xl fluid>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="form.last"
                  :rules="rules.name"
                  color="orange"
                  label="姓"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="form.first"
                  :rules="rules.name"
                  color="orange"
                  label="名"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.email"
                  :rules="rules.email"
                  color="orange"
                  label="メールアドレス"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.tel"
                  color="teal"
                  label="電話番号"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.bio"
                  color="teal"
                  multi-line
                >
                  <div slot="label">
                    お問い合わせ内容
                  </div>
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <p>プライバシポリシーにご同意ください。</p>
                <v-checkbox
                  v-model="form.terms"
                  color="green"
                >
                  <div slot="label">
                    <a href="javascript:;" @click.stop="terms = true">プライバシーポリシー</a>
                  </div>
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-btn flat @click="resetForm">リセット</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!formIsValid"
              flat
              color="primary"
              type="submit"
            >送信</v-btn>
          </v-card-actions>
        </v-form>
        <v-dialog v-model="terms" width="600px">
          <v-card>
            <v-card-title class="title">プライバシーポリシー</v-card-title>
            <v-card-text>
              <policy-body/>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                flat
                color="purple"
                @click="terms = false"
              >Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
      <p class="mt-4 mb-5">
      お問い合わせフォームよりお問い合わせを頂きますと、サーバーよりお問い合わせ内容確認メールが自動送信されます。<br>
      お返事にお時間をいただく場合がございます。予めご了承いただきますようお願いいたします。<br>
      お問い合わせの内容によりましては、お電話させていただくことがございます。</p>
    </v-flex>
  </v-container>
</template>

<script>
import ContactService from '@/components/services/ContactService.vue'
import PolicyBody from '@/components/PolicyBody.vue'
export default {
  name: 'Contact',
  components: {
    PolicyBody
  },
  data () {
    const defaultForm = Object.freeze({
      first: '',
      last: '',
      email: '',
      tel: '',
      bio: '',
      terms: false
    })

    return {
      form: Object.assign({}, defaultForm),
      rules: {
        name: [val => (val || '').length > 0 || 'この項目は必須です。'],
        email: [val => (val || '').length > 0 || 'この項目は必須です。']
      },
      sendContact: false,
      terms: false,
      defaultForm
    }
  },

  computed: {
    formIsValid () {
      return (
        this.form.first &&
        this.form.last &&
        this.form.email &&
        this.form.terms
      )
    }
  },

  methods: {
    resetForm () {
      this.form = Object.assign({}, this.defaultForm)
      this.$refs.form.reset()
    },
    submit () {
      this.sendContact = true
      ContactService.postContact(this.form.last, this.form.first, this.form.email, this.form.bio, this.form.tel, (response) => {
        // お問い合わせ成功
        alert('お問い合わせを送信しました。')
        console.log(response)
      }, (error) => {
        // お問い合わせ失敗
        alert('お問い合わせの送信に失敗しました。')
        console.error(error)
      })
      this.resetForm()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/Contact.vue